$(function() {
	$('.slider').flickity({
		imagesLoaded: true,
		pageDots: false
	});
});
